/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeatureSwitchViewModel } from '../../models/feature-switch-view-model';

export interface GetFeatureSwitches$Params {
}

export function GetFeatureSwitches(http: HttpClient, rootUrl: string, params?: GetFeatureSwitches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureSwitchViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetFeatureSwitches.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FeatureSwitchViewModel>>;
    })
  );
}

GetFeatureSwitches.PATH = '/api/Permissions/GetFeatureSwitches';
